export default __webpack_public_path__ + "static/media/help-customer.caf53ea6.svg";